import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateParcours, type ParcoursDto } from "../api/parcoursApi";
import { queryKeys } from "../lib/queryKeys";

export function useUpdateParcours(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: ParcoursDto) => updateParcours(id, dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.parcours.all });
      qc.invalidateQueries({ queryKey: queryKeys.parcours.detail(id) });
      // Lieu/artist assignments changed → their scoped lists (for editors) may differ.
      qc.invalidateQueries({ queryKey: queryKeys.lieux.all });
      qc.invalidateQueries({ queryKey: queryKeys.artists.all });
    },
  });
}
